import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import DesktopVideoPlayer from './DesktopVideoPlayer';
import MobileVideoPlayer from './MobileVideoPlayer';

import config from '../../config';
import { sendIntercomEvent } from '../../common/events';
import detectIE from './utils/detectIE';

class VideoPlayer extends Component {
  static defaultProps = {
    progressThrottle: 10000,
  };

  state = {
    source: '',
    hasHitPlay: false,
    time: 0,
    isMobile: false,
    isIE: false,
  };

  componentWillMount = () => {
    const { initialTime, video } = this.props;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isIE = detectIE();
    const isVideoAlmostOver = video.get('duration') - video.get('progress') < 5;
    const time = initialTime || (isVideoAlmostOver ? 0 : video.get('progress')) || 0;
    const source = `${config.cloudfront.videoDomain}/${video.get('key')}/`;

    this.setState({ source, time, isMobile, isIE });
  };

  componentDidMount = () => {
    document.body.classList.add('hide-intercom');
  };

  componentWillUnmount = () => {
    document.body.classList.remove('hide-intercom');
  };

  goBack = () => {
    if (this.props.backTo) {
      this.props.history.push(this.props.backTo);
    }
    if (this.props.onBackTo) {
      this.props.onBackTo();
    }
  };

  intercomOnPlay = () => {
    const { hasHitPlay } = this.state;
    const { title, sendToIntercom, intercomEventName } = this.props;

    // This will only run the first time the video is played after page load.
    if (!hasHitPlay && !!sendToIntercom) {
      this.setState(
        state => ({
          hasHitPlay: !state.hasHitPlay,
        }),
        () => sendIntercomEvent(intercomEventName || 'watched_video', { videoTitle: title })
      );
    }
  };

  render = () => {
    const { source, time, isMobile, isIE } = this.state;

    if (isMobile || isIE) {
      return (
        <MobileVideoPlayer
          source={source}
          time={time}
          goBack={this.goBack}
          onPlay={this.intercomOnPlay}
          {...this.props}
        />
      );
    } else {
      return (
        <DesktopVideoPlayer
          source={`${source}dash.mpd#t=${time}`}
          goBack={this.goBack}
          onPlay={this.intercomOnPlay}
          {...this.props}
        />
      );
    }
  };
}

export default withRouter(VideoPlayer);



// WEBPACK FOOTER //
// ./src/common/video/VideoPlayer.js